import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { cardDetail, loanDetail } from './../Services/account.service';
import { Router } from '@angular/router';
import { AccountService } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { Options } from "ng5-slider";
import { SettingService } from '../Services/setting.service';
import { CookieService } from '../Services/cookie';




@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  standalone:false,
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  cardDetail: cardDetail;
  loanDetail: loanDetail;
  options: Options;
  value: number = 0;
  imageError: string = "";
  imageChangedEvent: any = "";
  imagebase64: string = "";
  isImageSaved: boolean = false;
  imageId: number = 0;
  url: string = "";
  @ViewChild("avatarid") avatarimage: ElementRef;
  NewEMail: any;
  NewMOb: any;

  constructor(
    public commonP: CommonService,
    public auth: AuthService,
    private account: AccountService,
    private _router: Router,
    private toastr: ToastrService,
    public setting: SettingService, private cookieService: CookieService,
    public renderer: Renderer2
  ) {
    
  
    
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  async ngOnInit(): Promise<void> {
    this.options = {
      floor: 100,
      ceil: 200,
      enforceRange: false,
    };

    let UE =await this.cookieService.get("UpdatedEmail", true);
    if (UE) {

      this.NewEMail = JSON.parse(UE);

    }

    let UM =await this.cookieService.get("upM32B", true);
    if (UM) {

      this.NewMOb = JSON.parse(UM);

    }



  if(this.NewEMail != '' && this.NewEMail != undefined){

    this.toastr.success(
      "You have successfully changed your email address",
      "Email address updated"
    );
    this.cookieService.delete("UpdatedEmail");
  }

  if(this.NewMOb != '' && this.NewMOb != undefined){

    this.toastr.success(
      "You have successfully changed your mobile number",
      "Mobile number updated"
    );
    this.cookieService.delete("upM32B");
  }


    this.auth.accessToken = await this.commonP.Get("token");
    await this.commonP.presentLoading();
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            this.auth.detailuser = data?.response?.content;

            this.account
              .GetLoanDashboard(this.auth.accessToken)
              .then((data: any) => {
                if (data?.response?.code == 1) {
                  // this.commonP.hideLoading();
                  let CardDetails = data.response.content.cardDetails;
                  let LoanDetails = data.response.content.loanDetails;
                  console.log("AllCardDetails", CardDetails);
                  console.log("AllLoanDetails", LoanDetails);

                  console.log(
                    "CardDetails",
                    CardDetails.filter((x) => x.displayFlag == "Y")
                  );
                  console.log(
                    "LoanDetails",
                    LoanDetails.filter((x) => x.displayFlag == "Y")
                  );

                  this.cardDetail = CardDetails.filter(
                    (x) =>
                      x.displayFlag == "Y" && x.primaryOrSupplementary == "Y"
                  );
                  this.loanDetail = LoanDetails.filter(
                    (x) => x.displayFlag == "Y"
                  );

                  this.getAvatar();
                } else {
                  this.commonP.hideLoading();
                  this.commonP.ParseErrorAlert("", "", this._router, data);
                }
              });
          } else {
            await this.commonP.hideLoading();

            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.commonP.hideLoading();

          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }
  getAvatar() {
    this.setting.GetAvatar(this.auth.accessToken, {}).then((data: any) => {
      if (data?.response?.code == 1) {
        if (data?.response?.content.response) {
          let prefix = "data:image/jpeg;base64,";
          this.url = prefix.concat(data?.response?.content.response);
          console.log("Image", this.url);
          this.commonP.hideLoading();
        } else {
          this.url = data?.response?.content.response;
          console.log("Image", this.url);
          this.commonP.hideLoading();
        }
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }
  settingsUpdateEmail() {
    this._router.navigateByUrl("/SettingsUpdateEmail");
  }

  settingsUpdateMobileNumber() {
    this._router.navigateByUrl("/SettingsUpdateMobileNumber");
  }

  settings() {
    this._router.navigateByUrl("/Settings");
  }
  settingManageAddress() {
    this._router.navigateByUrl("/SettingManageAddress");
  }
  settingPushNotifications() {
    this._router.navigateByUrl("/SettingPushNotifications");
  }

  // fileChangeEvent(fileInput: any) {
  //   //

  //   this.imageError = null;
  //   if (fileInput.target.files && fileInput.target.files[0]) {
  //     const max_size = 5000000;
  //     const allowed_types = ["image/png", "image/jpeg"];
  //     const max_height = 2229;
  //     const max_width = 8386;

  //     if (fileInput.target.files[0].size > max_size) {
  //       this.imageError =
  //         "You have exceeded 5 MB. Please upload a valid format page.";
  //       this.commonP.ParseErrorAlert("", "", this._router, this.imageError);
  //       return false;
  //     }
  //     console.log(
  //       "fileInput.target.files[0].type",
  //       fileInput.target.files[0].type
  //     );
  //     console.log("allowed_types", allowed_types);
  //     if (!allowed_types.includes(fileInput.target.files[0].type)) {
  //       this.imageError =
  //         "Please upload a valid JPEG, PNG or JPG format. Max size: 5 MB";
  //       this.commonP.ParseErrorAlert("", "", this._router, this.imageError);
  //       return false;
  //     }
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       const image = new Image();
  //       image.src = e.target.result;
  //       image.onload = (rs) => {
  //         const img_height = rs.currentTarget["height"];
  //         const img_width = rs.currentTarget["width"];

  //         if (img_height > max_height && img_width > max_width) {
  //           this.imageError =
  //             "Maximum dimentions allowed " +
  //             max_height +
  //             "*" +
  //             max_width +
  //             "px";
  //           return false;
  //         } else {
  //           const imgBase64Path = e.target.result;
  //           const imagePrefix = imgBase64Path.split(",")[0];
  //           this.imagebase64 = imgBase64Path.split(",")[1];
  //           console.log("imagebase64", this.imagebase64);

  //           this.renderer.setAttribute(
  //             this.avatarimage.nativeElement,
  //             "src",
  //             imagePrefix + "," + this.imagebase64
  //           );
  //           this.showModal(2);
  //         }
  //       };
  //     };
  //     reader.readAsDataURL(fileInput.target.files[0]);
  //   }
  // }
  fileChangeEvent(fileInput: any): boolean | void {
    //

    this.imageError = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const max_size = 5000000;
      const allowed_types = ["image/png", "image/jpeg"];
      const max_height = 2229;
      const max_width = 8386;

      if (fileInput.target.files[0].size > max_size) {
        this.imageError =
          "You have exceeded 5 MB. Please upload a valid format page.";
        this.commonP.ParseErrorAlert("", "", this._router, this.imageError);
        return false;
      }
      console.log(
        "fileInput.target.files[0].type",
        fileInput.target.files[0].type
      );
      console.log("allowed_types", allowed_types);
      if (!allowed_types.includes(fileInput.target.files[0].type)) {
        this.imageError =
          "Please upload a valid JPEG, PNG or JPG format. Max size: 5 MB";
        this.commonP.ParseErrorAlert("", "", this._router, this.imageError);
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = (rs): boolean | void => {
          const img_height = rs.currentTarget["height"];
          const img_width = rs.currentTarget["width"];

          if (img_height > max_height && img_width > max_width) {
            this.imageError =
              "Maximum dimentions allowed " +
              max_height +
              "*" +
              max_width +
              "px";
            return false;
          } else {
            const imgBase64Path = e.target.result;
            const imagePrefix = imgBase64Path.split(",")[0];
            this.imagebase64 = imgBase64Path.split(",")[1];
            console.log("imagebase64", this.imagebase64);

            this.renderer.setAttribute(
              this.avatarimage.nativeElement,
              "src",
              imagePrefix + "," + this.imagebase64
            );
            this.showModal(2);
          }
        };
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  async resizeAndUpload() {
    let body = {
      Id: 5,
      type: "PNG",
      image: this.imagebase64,
    };
    await this.commonP.presentLoading();

    this.auth
      .SaveTempImage(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          this.imageId = data?.response?.content?.id;
          console.log("SaveTempImage", data);
          this.setting
            .UpdateAvatar(this.auth.accessToken, { ImageId: this.imageId })
            .then(async (data: any) => {
              if (data?.response?.code == 1) {
                this.getAvatar();
                this.toastr.success(
                  "You have successfully changed your profile photo",
                  "Profile photo updated"
                );
              } else {
                await this.commonP.hideLoading();
                this.commonP.ParseErrorAlert("", "", this._router, data);
              }
            });
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  Close() {}
  imageResize(event) {
    //
    const zoomImage = document.getElementById("avatarimage");
    const zoomValue = event;

    if (zoomValue) {
      zoomImage.style.transform = `scale(${zoomValue / 100})`;
    }

    //
    console.log("imageResize", event);

    // let newOptions: Options = Object.assign({}, this.options);
    // newOptions.floor = this.minmumValue;
    // newOptions.ceil=this.highValue
    // this.options = newOptions;
  }
}
